import { render, staticRenderFns } from "./GameStats.vue?vue&type=template&id=1240df76&scoped=true"
import script from "./GameStats.vue?vue&type=script&lang=js"
export * from "./GameStats.vue?vue&type=script&lang=js"
import style0 from "./GameStats.vue?vue&type=style&index=0&id=1240df76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1240df76",
  null
  
)

export default component.exports